import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "mt_cookie_consent_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setShow(true);
  }, []);

  if (!show) return null;

  function accept() {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, ts: Date.now() }));
    setShow(false);
  }

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-50 bg-[#0F0F0F] border-t border-border px-6 py-4 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-sm"
    >
      <div className="text-neutral-300 max-w-3xl">
        <span className="font-[Chivo] text-white">Cookies.</span>{" "}
        We use only essential first-party cookies to keep you signed in. No tracking, no advertising.{" "}
        <Link to="/legal/cookies" className="text-[#007AFF] hover:underline">Learn more</Link>
      </div>
      <div className="flex items-center gap-2">
        <button
          data-testid="cookie-accept"
          onClick={accept}
          className="px-4 py-2 bg-[#007AFF] hover:bg-[#3395FF] text-white text-sm font-[Chivo] tracking-wide"
        >
          Got it
        </button>
        <button data-testid="cookie-close" onClick={accept} aria-label="Close" className="text-neutral-500 hover:text-white p-1">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
